const MODULE_URL = 'hubs';

export default {
  MODULE_URL: MODULE_URL,
  SESSIONS_URL: MODULE_URL,

  STATS_URL: MODULE_URL + '/stats',

  SESSION_CREATED: 'hub_created',
  SESSION_REMOVED: 'hub_removed',
  SESSION_UPDATED: 'hub_updated',
  SESSION_COUNTS_UPDATED: 'hub_counts_updated',

  HUB_MESSAGE: 'hub_message',
  HUB_STATUS_MESSAGE: 'hub_status',

  USER_VIEW_ID: 'hub_user',
};
